import api from '../../services/api';
import { Creators } from '../ducks/chatbot';
import { call, put } from 'redux-saga/effects';
import store from '../../store';
import { getGeolocation } from './geolocation';

export function* getChatbotDataPrepared({ props }) {
  let data = {};
  let coords = yield getGeolocation();
  const products = store.getState().product.data;
  const chatbotData = store.getState().chatbot.data;

  Object.keys(props.steps).forEach(key => {
    const item = props.steps[key];
    const excludedKeys = ['options_start', 'question_finish'];

    if (item && item.value && !excludedKeys.includes(key)) {
      data[key] = item.value;
    }
  });

  Object.keys(chatbotData).forEach(key => {
    let item = chatbotData[key];

    if (item.asMutable) {
      item = item.asMutable();
    }

    if (item) {
      data[key] = item;
    }
  });

  data = { ...data, coords, products };

  return data;
}


export function* postChatbot(props) {
  try {
    const data = yield getChatbotDataPrepared({ props });

    yield put(Creators.chatbotRequest());
    yield call(api.post, 'public/chatbot', { data, action: 'save' });

    yield put(Creators.chatbotSuccess());
  } catch (err) {
    yield put(Creators.chatbotError({ err }));
  }
}

export function* setChatbotSaga({ value, props, is_finish }) {
  yield put(Creators.setChatbot(props.step.id, value));

  if (is_finish) {
    yield postChatbot(props);
  }

  if (props.triggerNextStep) {
    props.triggerNextStep({ trigger: props.trigger });
  }
}